import { RESET_APP } from '../actions/index';
import {
  UPDATE_LANGUAGE
} from '../actions/language';
import {
  LOCATION_STEP_BACK,
  LOCATION_STEP_FORWARD,
  RECEIVE_LOCATIONS,
  SELECT_CITY,
  SELECT_COUNTRY,
  SELECT_FACILITY,
  SELECT_LOCATION,
  SELECT_LOCATION_ID,
  SELECT_PROVINCE_STATE,
  GO_DIRECT,
  SET_USED_BOOKING_LOCAL_STORAGE,
  DISABLE_USED_BOOKING_LOCAL_STORAGE
} from '../actions/bookingLocation';

const initialState = {
  locationsData: [],
  selectedLocationId: 0,
  selectedLocation: null,
  step: 1, // LocationStep.Country
  selectedCountry: '',
  selectedCountryCanadian: true,
  selectedProvinceState: '',
  selectedCity: '',
  selectedCityUnique: false,
  selectedFacility: '',
  done: false,
  goDirect: false,
};

export const isCityUnique = (locations, city) => {
  let occurences = 0;
  for (let i = 0; i < locations.length; i++) {
    if (locations[i].city === city) {
      occurences += 1;
      if (occurences > 1) return false;
    }
  }
  if (occurences === 0) return false;
  return true;
}

export const isCountryCanadian = country => {
  return country === 'Canada';
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_STEP_BACK:
      return {
        ...state,
        step: Math.max(state.step - 1, 0)
      };
    case LOCATION_STEP_FORWARD:
      return {
        ...state,
        step: state.step + 1
      };
    case RECEIVE_LOCATIONS:
      return {
        ...state,
        locationsData: action.locations,
        captchaResponse: ''
      };
    case RESET_APP:
      return { ...initialState };
    case UPDATE_LANGUAGE:
      return {
        ...state,
        language: action.language
      };
    case SELECT_COUNTRY:
      return {
        ...state,
        selectedCountry: action.country,
        selectedCountryCanadian: isCountryCanadian(action.country)
      };
    case SELECT_PROVINCE_STATE:
      return {
        ...state,
        selectedProvinceState: action.provinceState
      };
    case SELECT_CITY:
      const cityIsUnique = isCityUnique(state.locationsData, action.city);
      return {
        ...state,
        selectedCity: action.city,
        selectedCityUnique: cityIsUnique,
        done: cityIsUnique ? true : false
      };
    case SELECT_FACILITY:
      return {
        ...state,
        selectedFacility: action.facility,
        done: true
      };
    case SELECT_LOCATION:
      return {
        ...state,
        selectedLocation: action.location,
        selectedLocationId: action.location.locationId
      };
    case SELECT_LOCATION_ID:
      return {
        ...state,
        selectedLocationId: action.locationId
      };
    case GO_DIRECT:
      return {
        ...state,
        goDirect: action.toggle
      };
    case SET_USED_BOOKING_LOCAL_STORAGE:
      return {...state, usedBookingLocalStorage: action.usedBookingLocalStorage };
    case DISABLE_USED_BOOKING_LOCAL_STORAGE:
      return {...state, usedBookingLocalStorage: action.usedBookingLocalStorage };
    default:
      return state;
  }
};
